import { useEffect } from 'react';
import { useLanguage } from '../i18n';

const SOCIAL_PROFILES = [
  'https://www.instagram.com/nuclearteam1/',
  'https://www.tiktok.com/@nuclear.team1',
  'https://nuclearteam.itch.io/'
];

const PEOPLE = {
  mariano: { name: 'Mariano Paz', path: '/equipo/mariano-paz', jobTitle: 'Director de arte, pixel artist y animador', image: '/mariano.png' },
  nacho: { name: 'Ignacio Naval Esparrell', path: '/equipo/ignacio-naval-esparrell', jobTitle: 'Desarrollador de videojuegos, programador y productor', image: '/Portraits_Nacho.png' },
  manu: { name: 'Francisco Emanuel Diaz Ortiz', path: '/equipo/francisco-emanuel-diaz-ortiz', jobTitle: 'Concept artist, ilustrador y diseñador de entornos y props', image: '/manu.png' },
  tomas: { name: 'Tomás Heredia', path: '/equipo/tomas-heredia', jobTitle: 'Ingeniero informático, diseñador y desarrollador de videojuegos', image: '/Portraits_Tomi.png' }
};

const Seo = ({ member = null }) => {
  const { language } = useLanguage();

  useEffect(() => {
    const origin = window.location.origin;
    const person = member ? PEOPLE[member] : null;
    const title = person
      ? `${person.name} | ${language === 'es' ? 'CV y perfil profesional' : 'Résumé and professional profile'} | Nuclear Team`
      : language === 'es' ? 'Nuclear Team | Estudio indie creador de OP CHORI' : 'Nuclear Team | Indie studio behind OP CHORI';
    const description = person
      ? `${person.name}, ${person.jobTitle} en Nuclear Team. ${language === 'es' ? 'Consultá su experiencia, habilidades y proyectos destacados.' : 'Explore their experience, skills and featured projects.'}`
      : language === 'es'
        ? 'Nuclear Team es un estudio indie argentino de videojuegos, creador de OP CHORI y DeadJavu. Conocé nuestros juegos, arte y equipo.'
        : 'Nuclear Team is an Argentine indie game studio behind OP CHORI and DeadJavu. Discover our games, artwork and team.';
    const canonicalUrl = person ? `${origin}${person.path}` : `${origin}/`;

    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', canonicalUrl);
    document.querySelector('meta[property="og:type"]')?.setAttribute('content', person ? 'profile' : 'website');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    const organization = {
      '@type': 'Organization', '@id': `${origin}/#organization`, name: 'Nuclear Team',
      alternateName: ['Team Nuclear', 'NuclearTeam'], url: `${origin}/`, logo: `${origin}/nuclearLogo.png`,
      description, foundingLocation: { '@type': 'Country', name: 'Argentina' }, sameAs: SOCIAL_PROFILES
    };
    const game = {
      '@type': 'VideoGame', '@id': `${origin}/#op-chori`, name: 'OP CHORI',
      alternateName: ['OpChori', 'OP C.H.O.R.I.', 'O.P. Chori'],
      description: 'Run and gun indie ambientado en una Argentina caricaturesca y lleno de humor ácido.',
      gamePlatform: 'Windows', genre: ['Run and gun', 'Action', 'Indie'],
      author: { '@id': `${origin}/#organization` }, publisher: { '@id': `${origin}/#organization` },
      image: `${origin}/gallery/Pantalla_Inicio.png`
    };
    const personSchema = person ? {
      '@type': 'Person', '@id': `${canonicalUrl}#person`, name: person.name, url: canonicalUrl,
      image: `${origin}${person.image}`, jobTitle: person.jobTitle,
      worksFor: { '@id': `${origin}/#organization` }, memberOf: { '@id': `${origin}/#organization` },
      knowsAbout: ['Video game development', 'Game design', 'Pixel art', 'Indie games', 'OP CHORI']
    } : null;
    const graph = { '@context': 'https://schema.org', '@graph': [organization, game, ...(personSchema ? [personSchema] : [])] };

    let structuredData = document.getElementById('nuclear-team-structured-data');
    if (!structuredData) {
      structuredData = document.createElement('script');
      structuredData.id = 'nuclear-team-structured-data';
      structuredData.type = 'application/ld+json';
      document.head.appendChild(structuredData);
    }
    structuredData.textContent = JSON.stringify(graph);
  }, [language, member]);

  return null;
};

export default Seo;
